import React, {Fragment} from 'react';
import { Button, Card, CardBody, Container, Row, Col, Input, } from 'reactstrap';
import { TableStriped } from '../../../components/tables/TableStriped';
import { ModalCreateWSSanitaria } from '../../../components/worksheetsanitary/ModalCreateWSSanitaria';
import { useCreateWorkSheetSanitary } from '../../../hooks/worksheetsanitary/useCreateWorkSheetSanitary';
import { AlertDataTable } from '../../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


export const IndexCreateWorkSheetSaniray = () => {
    const{
        catWorkSheet,name_ws,id_type_sample,list_determinations, validaciones,
        method, 
        handleInputChange, handleSearchWSS, loading, 
        closeDialog, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,
        datadeterminations,handleUpdateValues,datatypesamples,handleSelectValues,formValues,navigateNewProcessWS,
        showDeleteAlert, modalAlert, closeDeleteAlert, handleClear, handleSearch, searchWorkSheetSanitary, handleExcelWorkSheet,
        loadingExport

    } = useCreateWorkSheetSanitary();
    // console.log(datadeterminations,"datadeterminationsIndexCreate");

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {
        
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                
                <Button 
                    color="primary" 
                    size="sm"
                    onClick={() => handleUpdate(rowData.idwsconfig)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    
                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => handleDelete(rowData.idwsconfig)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };
    
    return(
        <>
            <Fragment>
                <Container fluid={true} style={{  scrollBehavior: "smooth" , transform: "scale(0.8)",    width: "125%",    transformOrigin: "top left" }} >
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody className="p-1">
                                     <Col sm="12" className='p-l-0 p-r-0 pb-2 pt -3' >
                                        <TitleDataTable
                                            titleTable="Listado de Hojas de Trabajo"
                                            buttonActions={handleExcelWorkSheet}
                                            titleButton="Excel de Muestras"
                                            isDisbled={loadingExport}
                                            loadingIsDisabled={loadingExport}
                                            titleCreate="Crear Muestra"
                                            buttonActionsCreate={handleCreate}
                                            actionInput={handleSearch}
                                            valueFilter={searchWorkSheetSanitary}
                                            filterLocalStorage={true}
                                            cleanFilterLocalStorage={handleClear}
                                        />
                                    </Col>
                                    <div className="table-responsive">
                                        <DataTable
                                            value={catWorkSheet}
                                            paginator
                                            rows={15}
                                            responsiveLayout="scroll"
                                            rowsPerPageOptions={[15, 50, 100]} 
                                            className="data-table p-datatable-striped p-datatable-sm"
                                            emptyMessage={
                                                <div className="text-center">
                                                    <img
                                                        src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                        style={{ width: "32%" }}
                                                        alt="Sin resultados"
                                                    />
                                                    <br />
                                                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                        No se encontraron resultados.
                                                    </p>
                                                </div>
                                            }
                                        >
    
                                            <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                            <Column field="name_ws" header="Nombre" headerStyle={headerStyle} style={cellStyle} />
                                            <Column field="name_type_sample" header="Tipo de muestra" headerStyle={headerStyle} style={cellStyle} />
                                            <Column 
                                                header="Determinaciones" 
                                                body={(rowData) => (
                                                    rowData?.list_determinations?.length
                                                    ? rowData.list_determinations.map(det => det.name).join(", ")
                                                    : "---"
                                                )} 
                                                headerStyle={headerStyle} 
                                                style={cellStyle} 
                                                />
                                            <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                        </DataTable>
                                    </div>
                             
                               
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {showDeleteAlert && (
                        <AlertDataTable
                            titleAlert="Eliminar hoja de trabajo"
                            visibleAlert={modalAlert}
                            onHideAlert={closeDeleteAlert}
                            sizeAlert="medium-dialog delete-method"
                            messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar la hoja de trabajo?"
                            alert1={true}
                            titleAlert1={name_ws}
                            buttonAcept
                            titleNotLoading="Eliminar"
                            titleDanger="Cancelar"
                            actionAcept={saveDelete}
                        />

                    )}
                </Container>
                <ModalCreateWSSanitaria
                {
                    ...{
                        catWorkSheet, name_ws,id_type_sample,list_determinations,datadeterminations, validaciones,
                        method, 
                        handleInputChange, handleSearchWSS, loading, 
                        closeDialog, modal, modalTitle,
                        saveCreate, saveUpdate, saveDelete,
                        nextPage, previousPage, goToPage, totalPageCount, currentPage,
                        handleUpdateValues,datatypesamples,handleSelectValues,formValues
                    }
                }
                />
            </Fragment>
        </>
    )
}
